// Название соцсети по ссылке — для alt иконки внутри ссылки.
// В static-info у соцсети есть только link и картинки, подписи нет, а ссылка из одной
// иконки без alt для скринридера и PageSpeed «без названия».
const SOCIALS = [
    [/wa\.me|whatsapp/i, 'WhatsApp'],
    [/max\.ru/i, 'MAX'],
    [/rutube/i, 'Rutube'],
    [/t\.me|telegram/i, 'Telegram'],
    [/vk\.com|vk\.ru/i, 'ВКонтакте'],
    [/youtube|youtu\.be/i, 'YouTube'],
    [/ok\.ru/i, 'Одноклассники'],
    [/dzen\.ru/i, 'Дзен'],
];

export const useSocialName = () => {
    const socialName = (link = '') => SOCIALS.find(([re]) => re.test(link))?.[1] || 'Соцсеть';

    return { socialName };
};
